import React, { FC } from 'react';
import moment from 'moment';

import { fc } from 'i18n';
import { arrowRightFilled, crossFilled } from 'assets/icons';
import { IRunway, IRunwayStatus } from 'types/redux/runways';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { RunwayStatusColumn } from './runway-status-column';

import styles from './styles.module.css';

interface IRunwayStatusTileProps {
  runway: IRunway | null;
  statusInfo: IRunwayStatus;
}

const CATS: Record<string, number> = {
  CAT_I: 1,
  CAT_II: 2,
  CAT_III: 3,
};

export const RunwayStatusTile: FC<IRunwayStatusTileProps> = ({ runway, statusInfo }) => {
  const direction = runway?.directions?.[statusInfo.directionIndex];
  const isClosed = statusInfo.mode === 'CLOSED';
  const status = statusInfo.operational ? ['OPER'] : statusInfo.reasons?.map((reason) => reason.slice(0, 4)) || ['-'];

  const columns = [
    { value: [runway?.number || '-'], label: 'RWY' },
    { value: [statusInfo?.ilsMode ? CATS[statusInfo.ilsMode] : '-'], label: 'CAT' },
    { value: status, label: 'SET' },
    { value: [direction || '-'], label: 'DIR' },
    { value: [statusInfo.mode], label: 'MODE' },
  ];

  const getFormattedDate = (date?: string) => (date ? moment(date).format('DD/MM/YYYY, HH:mm:ss') : '');

  return (
    <div className={styles.tile}>
      <div className={styles.header}>
        <span className={`${styles.headerText} ${styles.bold}`}>{`${fc('updated at')}:`}</span>
        &nbsp;
        <span className={styles.headerText}>{moment(statusInfo.statusAt).format('DD/MM/YYYY, HH:mm:ss')}</span>
      </div>
      <div className={styles.content}>
        <div className={styles.row}>
          {columns.map((column, index) => {
            const statusAt = getFormattedDate(statusInfo.statusAt);
            const ilsModeSince = getFormattedDate(statusInfo.ilsModeSince);
            const modeStatus = !!ilsModeSince && ilsModeSince !== statusAt ? ilsModeSince : undefined;

            return <RunwayStatusColumn key={index} label={column.label} value={column.value} statusAt={modeStatus} />;
          })}
          <div className={`${styles.column} ${styles.icon}`}>
            <SvgWrapper
              className={!isClosed && !!statusInfo.directionIndex ? styles.rotatedIcon : ''}
              width={15.6}
              height={15.6}
              details={isClosed ? crossFilled : arrowRightFilled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
